var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleGmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5296_12143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45456 18.0512V8.77837L2.57878 6.14747L0 4.6875V16.4148C0 17.3202 0.733594 18.0512 1.63641 18.0512H5.45456Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5459 18.0511H22.3641C23.2696 18.0511 24.0005 17.3174 24.0005 16.4147V4.6875L21.0796 6.35972L18.5459 8.77828V18.0511Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45479 8.77838L5.06348 5.15522L5.45479 1.6875L12.0002 6.59662L18.5457 1.6875L18.9834 4.968L18.5457 8.77838L12.0002 13.6875L5.45479 8.77838Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5459 1.68785V8.77872L24.0005 4.68785V2.506C24.0005 0.482409 21.6905 -0.671185 20.0733 0.542408L18.5459 1.68785Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.68789L2.50866 6.56945L5.45456 8.77876V1.68789L3.92719 0.542452C2.30719 -0.671236 0 0.482451 0 2.50595V4.68789Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5296_12143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18.0938,
    fill: "white",
    transform: "translate(0 0.046875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGmailIcon);
export default __webpack_public_path__ + "static/media/google-gmail-icon.ff2bd65505aef383a95218b7b76c78a4.svg";
export { ForwardRef as ReactComponent };